import React, { useState }  from "react";
import "../styles/login.css";
import { Formik, Form, Field, ErrorMessage } from "formik";
import logo from "../../assets/img/logo.jpg";
import { useNavigate } from "react-router-dom";

import { apiClient } from "../../config/api";
import * as Yup from "yup";

const LoginAdmin = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  
  const initialValues = {
    username: "",
    password: "",
  };

  const onSubmit = async (data) => {
    setIsLoading(true);
    setErrorMessage("");
    
    try {
      const response = await apiClient.post('/auth/login', data);
      
      if (response.data.error) {
        setErrorMessage(response.data.error);
      } else if (response.data.Login) {
        localStorage.setItem('token', response.data.token);
        console.log("connexion reussi");
        navigate("/auth/admin-section");
      }
    } catch (error) {
      setErrorMessage(error.userMessage || "Impossible de se connecter. Le serveur est peut-être hors ligne.");
    } finally {
      setIsLoading(false);
    }
  };

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("champ obligatoire"),
    password: Yup.string().required("champ obligatoire"),
  });

  return (
    <div className="login-wrapper">
      <img src={logo} alt="logo" />

      <div>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          <Form className="login-form">
            <h2>connexion</h2>
            {errorMessage && (
              <div style={{ color: 'red', marginBottom: '10px', fontSize: '14px' }}>
                {errorMessage}
              </div>
            )}
            <label>identifiant :</label>
            <ErrorMessage
              name="username"
              component="span"
              className="span-error"
            />
            <Field id="inputField" name="username" placeholder="identifiant" />

            <label>mot de passe :</label>
            <ErrorMessage
              name="password"
              component="span"
              className="span-error"
            />

            <Field
              id="inputField"
              name="password"
              type="password"
              placeholder="mot de passe"
            />

            <button type="submit" className="btn-login" disabled={isLoading}>
              {isLoading ? 'Connexion...' : 'se connecter'}
            </button>
          </Form>
        </Formik>
      </div>
    </div>
  );
};

export default LoginAdmin;
